import { put, call, takeEvery, select } from 'redux-saga/effects'
import { reset, change } from 'redux-form'
import { yesNoModal } from '../../modalsListeners/yesNoModal'
import dossierActionsTypes from '../../../constants/actions/dossier/dossier'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import messageModalActions from '../../../actions/modals/messageModal'
import { showLoader, hideLoader } from '../../../actions/common'
import {
  updateOptionalSuccess
} from '../../../actions/dossier/sales'
import { handleError } from '../../errors/errorManager'
import { initializeDossier } from '../commonDossierSagas'
import { v4 as uuidv1 } from 'uuid'
import { updateEconomicPlanFleet } from '../../../actions/management/management'

export function * createExtra ({ dossierExtra, resolve, reject, dossierExtraType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierExtraType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateOptionalSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))
    // changes(add & delete items changes state not form)
    newEconomic.optionals = economicState.optionals
    dossierExtra.dossierId = stateDossier.dossierId
    dossierExtra.amount = parseFloat(dossierExtra.amount)
    dossierExtra.cost = parseFloat(dossierExtra.cost)
    dossierExtra.indexFront = uuidv1()
    newEconomic.optionals = newEconomic.optionals || []
    newEconomic.optionals.push(dossierExtra)

    if (dossierExtraType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.optionals))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))

    yield put(messageModalActions.openSuccessMessageModal('MESSAGES.POST_TABLE_ITEM_SUCCESS'))
    yield call(resolve)
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('MESSAGES.POST_TABLE_ITEM_ERROR', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
      yield call(reject, customHandlerError)
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
      yield put(reset('economicPlanModal'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchCreateExtra () {
  yield takeEvery(dossierActionsTypes.CREATE_EXTRA, createExtra)
}

export function * updateExtra ({ dossierExtra, resolve, reject, dossierExtraType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierExtraType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateOptionalSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))
    // changes(add & delete items changes state not form)
    newEconomic.optionals = economicState.optionals
    yield put(showLoader())
    dossierExtra.amount = parseFloat(dossierExtra.amount)
    dossierExtra.cost = parseFloat(dossierExtra.cost)
    let index = dossierExtra.id ? newEconomic.optionals.findIndex(d => d.id === dossierExtra.id)
      : newEconomic.optionals.findIndex(d => d.indexFront === dossierExtra.indexFront)
    newEconomic.optionals[index] = dossierExtra

    if (dossierExtraType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.optionals))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))

    yield call(resolve)
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
      yield call(reject, customHandlerError)
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
      yield put(reset('economicPlanModal'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchUpdateExtra () {
  yield takeEvery(dossierActionsTypes.UPDATE_EXTRA, updateExtra)
}

export function * deleteExtra ({ dossierExtra, dossierExtraType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierExtraType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateOptionalSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))
    // changes(add & delete items changes state not form)
    newEconomic.optionals = economicState.optionals
    let index = dossierExtra.id ? newEconomic.optionals.findIndex(d => d.id === dossierExtra.id)
      : newEconomic.optionals.findIndex(d => d.indexFront === dossierExtra.indexFront)
    newEconomic.optionals.splice(index, 1)
    if (dossierExtraType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.optionals))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
      yield put(reset('economicPlanModal'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchDeleteExtra () {
  yield takeEvery(dossierActionsTypes.DELETE_EXTRA, deleteExtra)
}
